import { ETR_STAFF_ROLES } from '../constants'

export const isBranchStaff = (role: string) => {
  return role === ETR_STAFF_ROLES.BRANCHSTAFF || role === ETR_STAFF_ROLES.BRANCHSTAFFADMIN
}

export const isBranchAdmin = (role: string) => {
  return role === ETR_STAFF_ROLES.BRANCHSTAFFADMIN
}

export const isCollectionStaff = (role: string) => {
  return role === ETR_STAFF_ROLES.COLLECTIONSTAFF || role === ETR_STAFF_ROLES.COLLECTIONADMIN
}

export const isSQDStaff = (role: string) => {
  return role === ETR_STAFF_ROLES.SQDSTAFF || role === ETR_STAFF_ROLES.SQDADMIN
}

export const isSQDAdmin = (role: string) => {
  return role === ETR_STAFF_ROLES.SQDADMIN
}

export const isAgent = (isBranchStaff: boolean, role: string) => {
  return isBranchStaff === false && !role
}

export const isCancelable = (role: string, createBy: string, loginId: string) => {
  if (isBranchAdmin(role)) return true
  if (isBranchStaff(role)) return true
  if (isCollectionStaff(role)) return true
  if (isSQDAdmin(role)) return true
  if (isSQDStaff(role)) return true
  return createBy === loginId
}

export const isBranchCodeNotStartWithAorD = (branchCode = '') => {
  return !['A', 'D'].includes(branchCode)
}
